module.exports = __webpack_public_path__ + "static/media/Ship-Meraviglia-galleria-meraviglia.43f8f757.webp";